import {groupBy, invariant} from '@raison/toolbox';
import {Resource} from '@raison/types';
import {selectAssetsResource} from '~/redux/assets/assetsResource';
import {selectFinancesResource} from '~/redux/finances';
import {Assets} from '~/shared/api/legacy_services/Assets/Assets';

export type AssetType = keyof Assets['accounts'];

export type FilterType = (typeof filterTypes)[number];
export const filterTypes = ['account', 'wallet', 'token'] as const;

const mapAssetTypeToFilterType: Record<AssetType, FilterType> = {
    fiat: 'account',
    crypto: 'wallet',
    tokens: 'token',
};

export function selectAccountFilterResource(state: AppModel) {
    return Resource.all(selectFinancesResource(state), selectAssetsResource(state)).mapSuccess(
        ([{providers}, {accounts}]) => {
            const flatAccounts = Object.entries(accounts).flatMap(([type, items]) =>
                items.map(item => ({
                    ...item,
                    type: mapAssetTypeToFilterType[type as AssetType],
                }))
            );

            const accountsWithProviders = flatAccounts.map(acc => {
                const providerName = providers.find(p => p.id === acc.provider_id)?.name;
                invariant(!!providerName, `Provider ${acc.provider_id} not found`);
                return {
                    ...acc,
                    providerName,
                };
            });

            return groupBy(accountsWithProviders, acc => acc.providerName);
        }
    );
}
